import { Col, Form, Row, Stack } from "react-bootstrap";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import { RadioInput, colors } from "../../../libs";

import SwitchOffImage from "./../../..//assets/images/switch_off.svg";
import SwitchOnImage from "./../../../assets/images/switch_on.svg";

export const ProductPlanForm = styled(Form)`
  @media screen and (min-width: 1200px) {
    width: 50%;
  }
`;
export const ProductPlanFormFieldRow = styled(Row)`
  margin: 20px 0;
  padding: 0;
`;

export const ProductPlanFormFieldCol = styled(Col)``;

export const ProductPlanFormSwitch = styled(Form.Check)`
  display: inline-block;
  margin-left: 10px;
  .form-check-input {
    cursor: pointer;
    width: 40px;
    height: 20px;
    color: ${colors.text.white};
    background-color: #1e2025;
    border: 1px solid rgba(255, 255, 255, 0.5);
    background-image: url(${SwitchOffImage});
    &:focus {
      background-image: url(${SwitchOffImage});
      border-color: transparent;
      box-shadow: none;
      border: 1px solid rgba(255, 255, 255, 0.5);
    }
    &:checked {
      background-color: #b7f84d;
      border-color: #b7f84d;
      background-image: url(${SwitchOnImage});
    }
  }
`;

export const CustomDatePicker = styled(DatePicker)`
  width: 100%;
  padding: 15px;
  border-radius: 0.25rem;
  background: #1e2025;
  outline: none;
  border: 1px solid transparent;
  color: #fff;

  &.error {
    border: 1px solid red;
  }
`;

export const PlanTypeOptionsWrapper = styled(Stack)`
  width: 100%;
`;

export const ExpiryOptionsWrapper = styled(Stack)`
  width: 100%;
`;

export const ExpirationRadioInput = styled(RadioInput)`
  border: none;
`;
